import { useRef } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { useResizeObserver } from './useResizeObserver.js';

export const ViewCount = ({ viewCount, setViewCount }) => {
    const options = [5, 10, 15, 20, 50, 100];
    const buttonRef = useRef(null);
    const { width: menuWidth } = useResizeObserver(buttonRef);

    return (
        <>
            <Menu>
                <MenuButton 
                    ref={buttonRef} 
                    className="
                        group flex flex-grow md:flex-grow-0 justify-between items-center gap-1 sm:gap-2
                        bg-white hover:bg-gray-100 dark:hover:bg-zinc-600/30 dark:bg-zinc-700 px-3 py-1.5
                        font-semibold text-gray-600 dark:text-gray-200
                        focus-within:outline-none focus-within:ring-2 focus-within:ring-blue-500
                        rounded-2xl data-[open]:rounded-b-none
                        transition-all duration-100 ease-in-out delay-200 data-[open]:delay-0
                    "
                    aria-label="Select number of views to display"
                >
                    <span>表示数: {viewCount}</span>
                    <ChevronDownIcon 
                        className="size-5 inline-block text-gray-600 dark:text-gray-200 group-data-[open]:rotate-180 transition-transform duration-300 ease-in-out" 
                        aria-hidden="true" 
                    />
                </MenuButton>
                <MenuItems
                    transition
                    anchor="bottom"
                    style={{ width: `${menuWidth + 24}px` }}
                    className="
                        bg-white dark:bg-zinc-700 font-semibold text-gray-600 dark:text-gray-200 
                        focus:outline-none z-10 rounded-b-2xl rounded-t-none

                        grid transition-[grid-template-rows] duration-200 ease-in-out
                        grid-rows-[1fr]

                        data-[closed]:grid-rows-[0fr]
                    "
                >
                    <div className="overflow-hidden">
                        {options.map((option) => (
                            <MenuItem key={option}>
                                <button
                                    onClick={() => setViewCount(option)}
                                    className="group flex w-full items-center px-3 py-1.5 hover:bg-gray-100 dark:hover:bg-zinc-800 cursor-pointer"
                                >
                                    {option}
                                </button>
                            </MenuItem>
                        ))}
                    </div>
                </MenuItems>
            </Menu>
        </>
    );
};
